<div class="modal-header">
  <h4 class="modal-title pull-left">&nbsp;</h4>
  <button
    type="button"
    class="close pull-right circle-icon"
    aria-label="Close"
    role="button"
    (click)="modalRef.hide()"
  >
    <img src="../assets/images/cross.svg" />
  </button>
</div>
<div class="modal-body">
  <div class="thankyou-wrap">
    <img src="../assets/images/thankyou.svg" />
    <h3 class="thank-heading">Thank You for Signing Up</h3>
    <h5 class="thank-sub-heading">
      Please check your email to activate your account.
    </h5>
  </div>
</div>
